import React from 'react';
import { Accordion, Panel } from 'baseui/accordion';
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader, ROLE, SIZE } from 'baseui/modal';
import { DIVIDER, SIZE as TABLE_SIZE, Table } from 'baseui/table-semantic';
import { Textarea } from 'baseui/textarea';
import { HeadingXSmall } from 'baseui/typography';
import type { Project } from '../../../types/project';
type ProjectDetailsModalPropsT = {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  project: Project;
};
const ProjectDetailsModal = (props: ProjectDetailsModalPropsT) => {
  const {
    showModal,
    setShowModal,
    project
  } = props;
  return <Modal onClose={() => setShowModal(false)} closeable isOpen={showModal} animate autoFocus role={ROLE.dialog} size={SIZE.full}>
      <ModalHeader>{project.name}</ModalHeader>

      <ModalBody>
        <div>Project ID: {project.id}</div>
        <div>
          <HeadingXSmall>Task Level Questionnaires</HeadingXSmall>
          {(project.taskLevelQuestionnaire || []).map(questionnaire => <div key={questionnaire.questionnaireId}>{questionnaire.questionnaireId}</div>)}
        </div>
        <div>
          <HeadingXSmall>Annotation Labels</HeadingXSmall>
          <Accordion>
            {project.configuration.annotationLabel.map(label => <Panel key={label.title} title={label.title}>
                <Table size={TABLE_SIZE.spacious} divider={DIVIDER.grid} columns={['Property', 'Value']} data={[['Label Title', label.title], ['Label Description', label.description], ['Label Instance Label Title', label.instanceLabelTitle], ['Is Required', label.isRequired ? 'true' : 'false'], ['Max', label.max], ['Style', JSON.stringify(label.style || {}, null, 2)], ['Yolo Label mapping', label.metadata?.yoloLabelName], ['Tools', label.tools], ['Questionnaires', (label.questionnaire || []).map(questionnaire => questionnaire.questionnaireId).join(', ')]]} />
              </Panel>)}
          </Accordion>
        </div>
        <div>
          <HeadingXSmall>Questionnaire</HeadingXSmall>
          <Accordion>
            {Object.keys(project.configuration.questionnaires).map(questionnaireKey => <Panel key={questionnaireKey} title={questionnaireKey}>
                {/* @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'. */}
                <div>Name: {project.configuration.questionnaires[questionnaireKey].name}</div>
                <div>
                  JSON:{' '}
                  <Textarea value={JSON.stringify(
              // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
              project.configuration.questionnaires[questionnaireKey].questionnaire, null, 2)} readOnly placeholder="No questionnaire data" rows={10} />
                </div>
              </Panel>)}
          </Accordion>
        </div>
      </ModalBody>
      <ModalFooter>
        <ModalButton onClick={() => setShowModal(false)}>Close</ModalButton>
      </ModalFooter>
    </Modal>;
};
export default ProjectDetailsModal;